export default __webpack_public_path__ + "static/media/sunwdokuz8.745f344e.jpg";